export default __webpack_public_path__ + "static/media/PÅL.960541a7.jpeg";